import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeUpdateReferralMutation as useDeUpdateReferralMutationType } from "@/modules/patients/detail/referral/de/services/__generated__/useDeUpdateReferralMutation.graphql"

const updateReferralMutation = graphql`
  mutation useDeUpdateReferralMutation($input: De_updateReferralLetterInput!) {
    de_updateReferralLetter(input: $input) {
      de_ReferralLetter {
        id
        progressNoteId
        createdAt
        createdBy
        fileId
        patientId
        reasoning
        referralId
        signedAt
        updatedAt
        updatedBy
        concludedAt
        concludedBy
        medicationIds
        conditions
        allergies
        icdDiagnosis {
          id
          isAssociation
          diagnosisCode
          primaryCode
          secondaryCode
          associationType
          text
        }
        progressNote {
          pointOfCare {
            pointOfCareSpecialty {
              id
              language
              synonym
              word
            }
          }
        }
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
      }
    }
  }
`

const useDeUpdateReferralMutation = () => {
  const [commit, isFlight] = useMutation<useDeUpdateReferralMutationType>(updateReferralMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeUpdateReferralMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdateReferralMutation }
